import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";
import SchemaJsonLd from "@/components/base/SchemaJsonLd";
import { getHotArticles, getLatestArticles } from "@/utils/news";
import HeroSection from "@/pages/home/components/HeroSection";
import BreakingBand from "@/pages/home/components/BreakingBand";
import CategoryBlock from "@/pages/home/components/CategoryBlock";
import HotRanking from "@/pages/home/components/HotRanking";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutBand from "@/pages/home/components/AboutBand";

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      name: "51cg网 - 最新爆料与即时快讯首页",
      description:
        "51cg网首页聚合最新爆料、即时快讯、今日速递与突发消息，按栏目与热度整理当日热点。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "ItemList",
      name: "今日热榜",
      itemListElement: getHotArticles(8).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `https://ryvucy.cn/article/${item.id}`,
        name: item.title,
      })),
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "首页",
          item: "https://ryvucy.cn/",
        },
      ],
    },
  ],
};

export default function Home() {
  const total = getLatestArticles().length;

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex-1 pb-4">
        <h1 className="sr-only">
          51cg网 - 最新爆料、即时快讯与今日速递，突发消息抢先看
        </h1>
        <SchemaJsonLd data={schema} />

        <HeroSection />
        <BreakingBand />

        <div className="mt-14 space-y-12 md:mt-20 md:space-y-16">
          <div className="mx-auto max-w-[1400px] px-4 md:px-6">
            <p className="flex flex-wrap items-center gap-x-3 gap-y-1 border-l-2 border-accent-500 pl-3 text-sm text-foreground-600">
              <span className="font-medium text-foreground-900">今日速递已就绪</span>
              <span>共 {total} 条内容正在更新，涵盖六大栏目，随时刷新随时有料。</span>
            </p>
          </div>
          <CategoryBlock slug="kuaixun" />
          <CategoryBlock slug="minsheng" />
          <HotRanking />
          <CategoryBlock slug="baoliao" />
          <SubscribeSection />
          <FaqSection />
        </div>
        <div className="mt-14 md:mt-20">
          <AboutBand />
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}